export const ALPHABET_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const initialExperimentConfiguration = {
  name: '',
  description: '',
  groups: [
    {
      name: 'Group A', version: 1, usage: [], idx: 0,
    },
    {
      name: 'Group B', version: 1, usage: [], idx: 1,
    },
  ],
  scheme: 'random',
  parameters: {},
  usage: [],
  active: true,
  version: 1,
};
